import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/components/images/empty-team-icon.png'


const _hoisted_1 = {
  class: "NoRecord",
  "data-test": "rule-dialog"
}
const _hoisted_2 = { class: "NoRecord__container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "NoRecord__title" }, "KK币赚取记录", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "NoRecord__des" }, "展示近一年的组队赚KK币记录", -1)
const _hoisted_5 = { class: "NoRecord__block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "NoRecord__img",
  src: _imports_0
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "NoRecord__subdes" }, "暂无过往组队记录", -1)
const _hoisted_8 = ["onClick"]

import { nextTick } from 'vue';
import { useBtn } from '@/hooks/useBtn';


export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {



function onClose () {
  emit('close');
}

const { btnMode, buttonText, clickBtn } =
  useBtn();

function onClick () {
  clickBtn(`${buttonText.value}-记录弹窗`);
  nextTick(() => {
    onClose();
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", {
          class: _normalizeClass(["NoRecord__btn", { 'NoRecord__btn--disabled': _unref(btnMode) === 'full' }]),
          onClick: onClick
        }, _toDisplayString(_unref(buttonText)), 3)
      ])
    ]),
    _createElementVNode("div", {
      class: "NoRecord__close",
      "data-test": "close-btn",
      onClick: _withModifiers(onClose, ["stop"])
    }, null, 8, _hoisted_8)
  ]))
}
}

})